/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "8e9617d9bef95641af6370958916682c365f6e44";
